exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-bg {\r\n    background-color: #053c6d;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n}\r\n\r\n.register-box {\r\n    width: 600px;\r\n}\r\n.register-box .ng-busy{\r\n    top: -15px !important;\r\n}\r\n.login-logo {\r\n    padding-top: 0px;}\r\n.login-box,\r\n.register-box {    position: relative;\r\n    background-color: #eee;\r\n    /* margin-top: 6%; */\r\n    margin-top: 0;\r\n    border-radius: 10px;\r\n    box-shadow: 3px 4px 9px 0px rgba(0, 0, 0, 0.52);\r\n    display: table;\r\n    padding: 39px;\r\n    padding-bottom: 60px;\r\n}\r\n.login-bg > .register-box > .login-form-box > h1, .login-bg > .register-box > .login-form-box > h3{\r\n    margin: 20px 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/verify-email/verify-email.component.css
// module id = ../../../../../src/app/verify-email/verify-email.component.css
// module chunks = main